import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SplideCore from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { useMediaQuery } from 'react-responsive';

const slideData = [
  {
    srcDesktop: 'https://dps2wxsijib8x.cloudfront.net/atst/BannerPrimero.png',
    srcTablet: 'https://dps2wxsijib8x.cloudfront.net/atst/tablet/BannerPrimeroTablet.png',
    srcMobile: 'https://dps2wxsijib8x.cloudfront.net/atst/movil/BannerPrimeroMovil.png',
    badge: 'Comunicación profesional',
    title: 'Comunicación a Prueba de Todo',
    description: 'Equipos robustos y fiables para mantener a tu empresa siempre conectada, en oficina y en campo.',
    btnText: 'Ver productos',
    btnHref: '/productos',
  },
  {
    srcDesktop: 'https://dps2wxsijib8x.cloudfront.net/atst/BannerSegundo.png',
    srcTablet: 'https://dps2wxsijib8x.cloudfront.net/atst/tablet/BannerSegundoTablet.png',
    srcMobile: 'https://dps2wxsijib8x.cloudfront.net/atst/movil/BannerSegundoMovil.png',
    badge: 'Radios portátiles',
    title: 'Alcanza Cada Rincón',
    description: 'Comunicación rápida y eficiente para equipos en movimiento. Productividad garantizada en cualquier terreno.',
    btnText: 'Ver productos',
    btnHref: '/productos',
  },
];

export default function BannerNuevo() {
  const splideRef = useRef(null);
  const splideInstance = useRef(null);

  const isDesktop = useMediaQuery({ minWidth: 1224 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1224 });

  useEffect(() => {
    if (splideRef.current) {
      if (splideInstance.current) splideInstance.current.destroy();
      splideInstance.current = new SplideCore(splideRef.current, {
        type: 'loop',
        autoplay: true,
        interval: 5000,
        speed: 800,
        pauseOnHover: true,
        arrows: true,
        pagination: true,
        width: '100%',
      });
      splideInstance.current.mount();
    }
    return () => {
      if (splideInstance.current) splideInstance.current.destroy();
    };
  }, []);

  return (
    <div className="splide banner-splide" ref={splideRef}>
      <div className="splide__track">
        <ul className="splide__list">
          {slideData.map((slide, idx) => {
                    let src = slide.srcMobile;
            if (isDesktop) src = slide.srcDesktop;
            else if (isTablet) src = slide.srcTablet;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <li className="splide__slide" key={idx}>
                <div className="relative h-[280px] sm:h-[380px] md:h-[460px] lg:h-[540px] overflow-hidden">
                  {/* Imagen de fondo */}
                  <img
                    src={src || slide.srcDesktop}
                    alt={slide.title}
                    className="absolute inset-0 w-full h-full object-cover object-center"
                  />
                  {/* Overlay gradiente */}
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0f274b]/90 via-[#0f274b]/60 to-transparent" />

                  {/* Contenido */}
                  <div className="absolute inset-0 flex items-center">
                    <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
                      <div className="max-w-lg">
                        <span className="inline-block bg-[#00BEE7]/20 border border-[#00BEE7]/50 text-[#00BEE7] text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4">
                          {slide.badge}
                        </span>
                        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-3 md:mb-4">
                          {slide.title}
                        </h1>
                        <p className="text-sm sm:text-base md:text-lg text-blue-100 mb-6 md:mb-8 leading-relaxed">
                          {slide.description}
                        </p>
                        <div className="flex flex-wrap gap-3">
                          <Link
                            to={slide.btnHref}
                            className="bg-[#00BEE7] hover:bg-white text-[#0f274b] font-extrabold px-6 md:px-8 py-2.5 md:py-3 rounded-full text-sm md:text-base transition-all duration-200 shadow-lg shadow-black/20"
                          >
                            {slide.btnText}
                          </Link>
                          <Link
                            to="/contacto"
                            className="border-2 border-white/40 hover:border-[#00BEE7] text-white hover:text-[#00BEE7] font-extrabold px-6 md:px-8 py-2.5 md:py-3 rounded-full text-sm md:text-base transition-all duration-200"
                          >
                            Contactar
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
